import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as LockIcon } from "../../assets/icons/lock-keyhole.svg";
import NewButton, {
  NewButtonVariant,
} from "components/common/buttons/basicButton/NewButton";

const AcademyWithoutMerchantInfo = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div
        className="rounded-sm shadow-xl rounded-2xl  max-w-md w-full text-center px-36 py-12"
        style={{
          background: "oklch(70.4% 0.04 256.788)",
        }}
      >
        <div className="flex justify-center mb-6">
          <LockIcon className="h-16 w-16 text-red-500 drop-shadow animate-pulse" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {t("common.academyWithoutMerchant")}
        </h1>
        <p className="text-gray-600 mb-6 font-medium">
          {t("common.contactAdmin")}
        </p>
        <div className="p-12">
          <NewButton
            variant={NewButtonVariant.Primary}
            onClick={() => history.push("/")}
            fullWidth
          >
            {t("common.goHome")}
          </NewButton>
        </div>
      </div>
    </div>
  );
};

export default AcademyWithoutMerchantInfo;
